import React from "react";
import { Provider } from "react-redux";
import store from './store';
import CollectivePermission from "./containers/CollectivePermission.jsx";

function CollectivePermissionIndex () {
    return (
        <Provider store={store}>
            <CollectivePermission />
        </Provider>
    )
}

export default CollectivePermissionIndex;


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/index.jsx